import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  loadingAuditTrail: false,
  refreshAuditTrail: false,
  panelsQuery: ''
}

/**
 * Create loading slice to show and hide a loader overlay
 * and to manage query across middle panel and right panel
 *
 * @type {Slice<{loading: boolean}, {hide(*): void, show(*): void}, string>}
 */
const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    show (state) {
      state.loading = true
    },
    hide (state) {
      state.loading = false
    },
    auditTrailLoading (state, action) {
      state.loadingAuditTrail = action.payload
    },
    refreshAuditTrail (state, action) {
      state.refreshAuditTrail = action.payload
    },
    panelsQuery (state, action) {
      state.panelsQuery = action.payload
    }
  }
})

export const loadingActions = loadingSlice.actions

export default loadingSlice.reducer
